<template>
  <v-carousel-item>
    <v-row class="pa-4" align="center" justify="center">
      <v-col class="pl-12 pr-10" cols="12" sm="12" md="6" lg="6" xl="6">
        <v-row>
          <v-card-text
            class="black--text font-weight-light display-3"
            :class="{
              'headline font-weight-regular': $vuetify.breakpoint.smAndDown
            }"
          >
            {{ blok.content }}
          </v-card-text>
          <v-card-text
            :class="{ 'subtitle-1': $vuetify.breakpoint.smAndDown }"
            class="black--text font-weight-thin text-left display-1"
          >
            {{ blok.smallcontent }}
          </v-card-text>
        </v-row>
      </v-col>
      <v-col
        align="center"
        class="pr-2 pt-0"
        xs="11"
        sm="12"
        md="6"
        lg="6"
        xl="6"
      >
        <v-img contain :position="blok.position" :src="blok.src"> </v-img>
      </v-col>
    </v-row>
  </v-carousel-item>
</template>

<script>
export default {
  name: "CarouselItem",
  props: ["blok"]
};
</script>

<style scoped></style>
